import React, { Component } from 'react';
import { connect } from 'react-redux';
import { trackMixpanelPageView } from '@helpers/post';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';

import Hero from './components/Hero/Hero';
import HowMathWorks from './components/HowMathWorks/HowMathWorks';
import CostEstimator from './components/CostEstimator/CostEstimator';
import WhatFeeCovers from './components/WhatFeeCovers/WhatFeeCovers';
import ComparisonTable from './components/ComparisonTable/ComparisonTable';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Coverage from './components/Coverage/Coverage';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import FooterCTA from './components/FooterCTA/FooterCTA';

import './PricingLanding.scss';

class PricingLanding extends Component {
  componentDidMount() {
    document.title = 'Go4 Pricing — One Flat 17.5% Service Fee';
    trackMixpanelPageView('/pricing');
  }

  goToSignUp = (source = 'unknown') => {
    trackMixpanelPageView('PricingLandingCTAClick', { source });
    this.props.history.push('/create-account/organization-type');
  };

  scrollToEstimator = () => {
    const el = document.getElementById('cost-estimator');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  render() {
    return (
      <div className="pricing-landing">
        <Hero
          onPrimaryCTA={() => this.goToSignUp('hero_primary')}
          onSecondaryCTA={this.scrollToEstimator}
        />

        <HowMathWorks />

        <CostEstimator
          id="cost-estimator"
          onPostJobClick={() => this.goToSignUp('cost_estimator')}
        />

        <WhatFeeCovers />

        <ComparisonTable />

        <HowItWorks />

        <Coverage onBackToEstimator={this.scrollToEstimator} />

        <Testimonials />

        <FAQ />

        <FooterCTA
          onPrimaryCTA={() => this.goToSignUp('footer_cta')}
          onSecondaryCTA={this.scrollToEstimator}
        />
      </div>
    );
  }
}

export default withQueryParamCapture(connect()(PricingLanding));
